import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyConversionBar from "@/components/StickyConversionBar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#f4f5f7]">
      <Header />
      <main className="flex-1 pb-12">{children}</main>
      <Footer />
      <StickyConversionBar />
    </div>
  );
}
